<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ 'Travel Allowance Acquittal for ' + taSubmission()?.taNumber }}
        </div>

        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (taSubmission()!.travellerCount! - 1) + ')'}}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
          }
        </div>
      </div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      <ta-approvals-table [taSubmission]="taSubmission()"
                          [contexts]="travelContexts"
                          heading="Travel Approvals"
      ></ta-approvals-table>
    </div>

    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Approved TA Value" [value]="originalTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Pending Acquittal TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Change in TA Value" [value]="acquittedValueChange()" [severity]="acquittedValueChange() === 0 ? 'text' : 'outlined'" [signed]="true"></ta-cost-bubble>
      <ta-cost-bubble title="Finalisation Payment Due" [value]="finalisationPaymentDue()" severity="primary"></ta-cost-bubble>
      <div class="w-full h-[1px] bg-surface-200"></div>
      @if (isPrePaid()) {
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
      }
      @if (overpaymentMade() > 0) {
        <ta-cost-bubble title="Overpayment Made" titleIcon="fa-regular fa-piggy-bank text-[#DC2626]" [value]="overpaymentMade()" severity="danger"></ta-cost-bubble>
      }
      <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
    </div>
  </div>

  @if (acquittalRole() === 'viewOnly') {
    <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">The travel allowance requires acquitting from travellers.</div>
    @if (travellersLength() > 1) {
      @if (permissionService.isDelegateTa(taSubmission())) {
        <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">* Indicates requiring acquittal from the Booking Officer</div>
      } @else {
        <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">* Indicates requiring acquittal from primary traveller</div>
      }
    }

    <div class="grid grid-cols-2 lg:w-1/2 w-full gap-y-2">
      <div class="col-span-2 h-[1px] bg-surface-200 my-[2px]"></div>
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Traveller</b></div>
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Acquittal Status</b></div>
      <div class="col-span-2 h-[1px] bg-surface-200 my-[2px]"></div>
      @for (traveller of taSubmission()?.travellers; track traveller;) {
        <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">{{traveller.details?.name}}</div>
        @if (!!traveller.acquittalDate) {
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Acquitted.</div>
        } @else {
          @if (traveller.isSelfAcquit) {
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Requires acquittal.</div>
          } @else {
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">{{'Requires acquittal from ' + acquitOnBehalfName()}}.</div>
          }
        }
        <div class="col-span-2 h-[1px] bg-surface-200 my-[2px]"></div>
      }
    </div>
  } @else {
    <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">
      @if (acquittalRole() === 'delegate') {
        <span>{{ 'You are the ' }}</span>
        <span class="font-semibold">{{'Booking Officer on ' + taSubmission()?.taNumber + '. ' }}</span>
        @if (acquitByDelegate().length === 0) {
          <span>{{ 'All travellers on this TA will acquit their own travel. You are able to acquit on their behalf if required.' }}</span>
        } @else if (acquitByDelegate().length === travellersLength()) {
          <span>{{ 'You are able to acquit ' }}</span>
          <span class="font-semibold italic">{{'all travel portions '}}</span>
          <span>{{ 'on this TA.' }}</span>
        } @else {
          <span>{{ 'You are able to acquit the travel portions for: ' }}</span>
          <dl class="py-3 px-6">
            @for (traveller of acquitByDelegate(); track traveller) {
              <li>{{traveller.details?.name}}</li>
            }
          </dl>
          <span>{{ 'The remaining travellers will acquit their own travel. You are able to acquit on their behalf if required.' }}</span>
        }
      }@else if (acquittalRole() === 'primaryTraveller') {
        <span>{{ 'You are the ' }}</span>
        <span class="font-semibold">{{'Primary Traveller on ' + taSubmission()?.taNumber + '. ' }}</span>
        @if (acquitByPrimary().length === 0) {
          <span>{{ 'You are only required to acquit ' }}</span>
          <span class="font-semibold italic">{{'your travel portion '}}</span>
          <span>{{ 'of the total TA. ' }}</span>
        } @else {
          <span>{{ 'You are required to acquit ' }}</span>
          <span class="font-semibold italic">{{'your travel portion '}}</span>
          <span>{{ 'of the total TA, ' }}</span>
          <span class="font-semibold italic">{{'plus '}}</span>
          <span>{{ 'the travel portions for: ' }}</span>
            <dl class="py-3 px-6">
              @for (traveller of acquitByPrimary(); track traveller) {
                <li>{{traveller.details?.name}}</li>
              }
            </dl>
        }
      } @else if (acquittalRole() === 'secondaryTraveller') {
        <span>{{ 'You are a traveller ' }}</span>
        <span class="font-semibold">{{'on ' + taSubmission()?.taNumber + '. ' }}</span>
        <span>{{ 'You are only required to acquit ' }}</span>
        <span class="font-semibold italic">{{'your travel portion '}}</span>
        <span>{{ 'of the total TA. ' }}</span>
      } @else if (acquittalRole() === 'viewOnlyTraveller') {
        <span>{{ 'You are a traveller ' }}</span>
        <span class="font-semibold">{{'on ' + taSubmission()?.taNumber + '. ' }}</span>
        <span>{{ 'You are ' }}</span>
        <span class="font-semibold italic">{{'not '}}</span>
        <span>{{ 'required to acquit any travel.' }}</span>
      }
    </div>

    <div class="w-full h-[1px] bg-surface-200"></div>
    @if (travellersLength() > 1) {
      <p-tabs
        [value]="selectedTravellerId()"
        (valueChange)="onTravellerTabChange($event)"
      >
        <p-tablist>
          @for (traveller of sortedTravellers(); track traveller; let ii = $index) {

            <!-- Disabled while saving: changing tab reloads the itinerary, which is no longer queued
                 behind an outstanding save and would show pre-save values. -->
            <p-tab [value]="traveller.travellerId ?? 0" [disabled]="!allowedTab(traveller) || store.isSavingData()">
              <div class="flex gap-2 items-center">
                @if (!!traveller.acquittalDate) {
                  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-primary-500 text-lg font-medium">
                    <i class="fa-solid fa-check fa-2xs"></i>
                  </div>
                } @else {
                  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-surface-200 text-lg font-medium">
                  </div>
                }
                {{ traveller.details?.firstName + " " + traveller.details?.surname }}
              </div>
            </p-tab>
          }
        </p-tablist>
      </p-tabs>
      <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">How this portion of the total TA Acquittal Value was calculated:</div>
    } @else {
      <div class="flex flex-col">
        <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">{{ singleTravellerValueHeading() }}</div>
      </div>
    }

    <div class="flex justify-between">
      <p-table [value]="currentItinerary()?.items ?? []" [loading]="isLoadingData()" [tableStyle]="{ 'min-width': '60rem' }" size="small" class="border-[1px] border-surface-400 rounded table-auto w-fit max-w-full">
        <ng-template #header>
          <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
            <th class="rounded-tl" pTooltip="Personal Days">PD</th>
            <th class="rounded-tl">Date</th>
            <th class="grow">Location</th>
            <th>Time</th>
            <th>Location</th>
            <th>Time</th>
            <th>Work Type</th>
            <th>Breakfast</th>
            <th>Lunch</th>
            <th>Dinner</th>
            <th>Incidentals</th>
            <th>Catering</th>
            @if (showOverseasColumn()) {
              <th pTooltip="Overseas meals & incidentals">Overseas</th>
            }
            <th class="rounded-tr">Day Trip Rate</th>
          </tr>
        </ng-template>
        <ng-template #body let-itineraryItem let-rowIndex="rowIndex">
          @let dayOffClass = itineraryDayRowClass(currentItinerary()?.items ?? [], rowIndex);
          <tr class="text-surface-800 text-xs font-['Roboto_Condensed']" [ngClass]="dayOffClass">
            <td [ngClass]="{'rounded-bl' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1)}">
              <p-check-box disabled inputId="personalDay1" [binary]="true" [ngModel]="itineraryItem.isPersonalDay"></p-check-box>
            </td>
            <td>
              <span>{{ itineraryItem.start | date:'dd/MM/yy' }}</span>
            </td>
            <td class="bg-primary-50">
              {{ taSubmissionDatasource.findLocation(itineraryItem.startLocationId, itineraryItem.startLocationNameId)?.name }}
            </td>
            <td class="bg-primary-50">
              <span>{{ itineraryItem.start | date:'HH:mm' }}</span>
            </td>
            <td class="bg-green-50">
              {{ taSubmissionDatasource.findLocation(itineraryItem.endLocationId, itineraryItem.endLocationNameId)?.name }}
            </td>
            <td class="bg-green-50">
              <span>{{ itineraryItem.end | date:'HH:mm' }}</span>
            </td>
            <td>
              {{ itineraryItem.workType}}
            </td>
            <td [ngClass]="{'text-surface-400' : (itineraryItem.breakfastValue === 0)}">
              {{ itineraryItem.breakfastValue | currency }}
            </td>
            <td [ngClass]="{'text-surface-400' : (itineraryItem.lunchValue === 0)}">
              {{ itineraryItem.lunchValue | currency }}
            </td>
            <td [ngClass]="{'text-surface-400' : (itineraryItem.dinnerValue === 0)}">
              {{ itineraryItem.dinnerValue | currency }}
            </td>
            <td [ngClass]="{'text-surface-400' : (itineraryItem.incidentalValue === 0)}">
              {{ itineraryItem.incidentalValue | currency }}
            </td>
            <td [ngClass]="{'text-surface-400' : (itineraryItem.cateringValue === 0)}">
              {{ itineraryItem.cateringValue | currency }}
            </td>
            @if (showOverseasColumn()) {
              <td [ngClass]="{'text-surface-400' : !itineraryItem.overseasValue}">
                {{ (itineraryItem.overseasValue ?? 0) | currency }}
              </td>
            }
            <td [ngClass]="{'rounded-br' : (rowIndex === (currentItinerary()?.items?.length ?? 0) - 1), 'text-surface-400' : (itineraryItem.dayTripValue === 0)}">
              {{ itineraryItem.dayTripValue | currency }}
            </td>
          </tr>
        </ng-template>
      </p-table>


      @if (travellersLength() > 1) {
        <div class="ml-4">
          <ta-cost-bubble title="Portion of Total TA Value (Acquitted)" [value]="partialTaValue()" severity="outlined"></ta-cost-bubble>
        </div>
      }
    </div>
    @if (travellersLength() > 1) {
      <div class="text-text-color text-sm font-normal font-['Inter'] leading-4">
        NOTE: When <b><i>ALL</i></b> travel portions have been acquitted, the TA will be forwarded for acquittal approval.
      </div>
    }
    <div class="w-full h-[1px] bg-surface-200"></div>

    @if (selectedTravellerAcquit()) {
      <div class="text-text-color text-sm font-normal font-['Inter'] leading-4">
        This travel portion has been acquitted.
      </div>
    } @else {
      <div class="flex gap-10 pt-4">
        <div class="flex flex-col gap-4">
          <div class="flex w-64 items-start gap-2">
            <p-check-box [(ngModel)]="travelCertified"
                         [binary]="true"
            ></p-check-box>
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter']">
              {{"I hereby certify that the travel undertaken by " + selectedTravellerName()  + " was in accordance with the details of this TA."}}
            </div>
          </div>
          <!-- Blocked while a save is queued: acquitting locks in the claimed values and is no
               longer queued behind the edit dialog's saves. -->
          <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmAcquit()"
                    [disabled]="!travelCertified || store.isSavingData()"
                    [loading]="store.isSavingData()">
            <i class="pi pi-check-circle pl-[1px]"></i>
            <span class="flex-1">Acquit Travel Allowance</span>
          </p-button>
        </div>
        <div class="h-min-full w-[1px] bg-surface-200"></div>
        <div class="flex flex-col gap-2 flex-1">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Comments</div>
          <textarea pTextarea [(ngModel)]="comments" placeholder="Click here to add comments supporting the TA Acquittal." rows="4" pSize="small" [autoResize]="true" class="lg:w-2/3 w-full"></textarea>
        </div>
      </div>
    }
  }

  @if (isPrePaid()){
    @if (!isPrepaymentProcessed() && canProcessPrepayment()) {
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
        This TA requires prepayment processing.
      </div>
      <div class="flex flex-col gap-4">
        <p-button [severity]="'primary'" styleClass="w-64 hover:cursor" (onClick)="confirmProcessPrepayment()">
          <i class="fa-regular fa-layer-group pl-[1px]"></i>
          <span class="flex-1">Prepayment Processed</span>
        </p-button>
      </div>
    } @else if (!isPrepaymentProcessed()) {
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
        Awaiting prepayment processing by Finance Unit.
      </div>
    }
    @if (canCancelPrepayment()) {
      <div class="flex flex-col gap-4">
        <p-button [severity]="'danger'" data-testId="cancel-prepayment-btn" styleClass="w-64 hover:cursor" (onClick)="confirmCancelPrepayment(isPrepaymentProcessed())">
          <i class="fa-regular fa-ban pl-[1px]"></i>
          <span class="flex-1">Cancel Prepayment</span>
        </p-button>
      </div>
    }
  }

</div>
